import React, { Component } from "react";
import _ from "lodash";
import { Form } from "antd";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import InputNumber from "../../../../components/number-input";
import config from "config";

const currencySymbols = config.CURRENCY_SYMBOL;

class TipsInput extends Component {
    handleInputChange = (value) => {
        this.props.setState({ tips: value });
    };

    getValue = () => {
        return this.props.tips;
    };

    getLabel = () => {
        return this.props.intl.formatMessage({ id: "tips" });
    };

    render() {
        return (
            <div>
                <Form.Item label={this.getLabel()} {...this.props.form}>
                    <InputNumber
                        style={{ width: `100%` }}
                        prefix={currencySymbols[this.props.storeCurrency]}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        precision={2}
                        value={this.getValue()}
                        min={0}
                        max={10000}
                        onChange={(e) => this.handleInputChange(e)}
                    />
                </Form.Item>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    lan: _.get(state, "setting.lan", "en"),
    storeCurrency: _.get(state, "store.storeCurrencyAndPricePlan.store_currency", "CAD"),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TipsInput));
